import { http } from 'vue'

export default {
  // load company_sku from the API server
  loadCompanySku (context, params = {}) {
    const withParam = params.with ? '?with=' + params.with : ''
    return http.get('company_skus/' + params.id + withParam)
  },
  // save company_sku at the store
  saveCompanySku (context, payload) {
    context.commit('SAVE_COMPANY_SKU', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_skus/actions.js